import { useState } from "react";
import { useFlags } from "launchdarkly-react-client-sdk";

import MedicalDocsModal from "components/Screens/Timeoff/ManageTimeoff/MedicalDocsModal";

import EmployeeAvatar from "components/Screens/Timeoff/TimeoffAdmin/EmployeeTimeOffDetails/EmployeeAvatar";
import Text from "components/common/Text";
import NoCommentView from "components/Screens/Timeoff/ManageTimeoff/PendingLeaves/PendingLeavesCard/NoCommentView";

import MedicalDocsIcon from "assets/images/medical-docs.svg";

import "./comment.scss";

function Comment({
  empImageSrc,
  customerImageSrc,
  pending,
  description,
  employeeName,
  requestId,
  reason = "",
  leaveType,
  documentsAttached,
  setReason = () => {},
  approvedReason,
  rejectedReason,
  loggedInUserType,
  actionByName,
  dateFrom,
  dateTo,
  noOfLeaves,
}) {
  const [medicalDocsModal, setMedicalDocsModal] = useState({
    show: false,
    id: null,
  });
  const { anniversaryBasedTimeOff } = useFlags();

  const handleCommentChange = (event) => {
    setReason(event.target.value);
  };

  return (
    <div className="space-y-1 comments-wrapper">
      <MedicalDocsModal
        open={medicalDocsModal.show}
        title="Medical Documents"
        leaveRequestId={requestId}
        closeModal={() =>
          setMedicalDocsModal({
            show: false,
            id: null,
          })
        }
        {...{ leaveType, dateFrom, dateTo, noOfLeaves }}
      />
      <div className="px-1 flex space-x-1">
        <EmployeeAvatar
          img={empImageSrc}
          size={{
            width: "44px",
            height: "44px",
            borderRadius: "50%",
          }}
        />
        {description ? (
          <div className="bg-white comment-container w-full">
            <p className="para-body-s-regular break-word" id="comment-leave">
              {description}
            </p>
            <p className="para-body-xs-regular neutral-20 comment-author" id="emp-name">
              {employeeName}
            </p>
          </div>
        ) : (
          <NoCommentView />
        )}

        {!anniversaryBasedTimeOff && leaveType === "Sick" && documentsAttached && (
          <div
            className="flex medical-docs-btn cursor-pointer"
            style={{ marginRight: "0" }}
            onClick={() =>
              setMedicalDocsModal({
                show: true,
                id: requestId,
              })
            }
          >
            <img src={MedicalDocsIcon} alt="medical docs" />
            <div className="flex flex-col" style={{ alignSelf: "center", marginLeft: "0.5rem" }}>
              <div className="pop-regular title-md medical-docs-btn-label">Medical Docs</div>
              <div className="label-sm pop-regular neutral-60" id="medical-docs-btn">
                View
              </div>
            </div>
          </div>
        )}
      </div>

      {approvedReason || rejectedReason || (pending && loggedInUserType === "customer") ? (
        <div className="px-1 flex space-x-1">
          <EmployeeAvatar
            img={customerImageSrc}
            size={{
              width: "44px",
              height: "44px",
              borderRadius: "50%",
            }}
          />
          <div className="w-full">
            {pending && (
              <Text
                value={reason}
                onChange={handleCommentChange}
                name="comments"
                multiline
                rows={1}
                placeholder="Add a comment (Optional)"
                size="medium"
              />
            )}

            {!pending && (approvedReason || rejectedReason) && (
              <div className="comment-details">
                <p className="para-body-s-regular break-word color-text-neutral-20" id="approved-reason">
                  {approvedReason || rejectedReason}
                </p>
                <p className="comment-details-sub" id="action-taken-by">
                  {actionByName}
                </p>
              </div>
            )}
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default Comment;
